<template>
  <div>
    <el-dialog :title="title" :visible.sync="visible" width="1200px"  top="5vh" append-to-body :close-on-click-modal="false" :fullscreen="true" custom-class="update-international-product-dialog">
      <el-form :model="propsParams" ref="form" :inline="true">
        <el-row>
          <el-col :span="24">
            <div class="form-item-wrapper">
              <el-form-item label="套餐名称" class="inline-form-item">
                {{propsParams.productName}}
              </el-form-item>
              <el-form-item label="套餐类型" class="inline-form-item">
                <el-tag>{{transferProductType(propsParams.productType)}}</el-tag>
              </el-form-item>
            </div>
            <el-form-item>
              <el-input v-model="searchCountry"  placeholder="区域名称" clearable style="width: 210px" />
            </el-form-item>
            <el-form-item >
              <el-button type="primary" icon="el-icon-search" @click="searchCountryPrices">搜索</el-button>
              <el-button type="success" icon="el-icon-plus"  @click="handleSelectGroupsData">新增使用区域</el-button>
              <el-button type="warning" icon="el-icon-delete"  @click="removeSelectProductCountry">清除套餐所有区域</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item>
              <el-input v-model="internationalPrice" placeholder="人民币价格" style="width:130px"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
              </el-input>
              <el-button type="primary" size="mini" @click="handleUpdateInternationalPrice" style="margin-left: 10px">按汇率设置价格</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-item-operator">
          <el-table ref="currencyTable"  :data="filteredCountryPrices" row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column prop="name" align="center" width="180">
              <template #header>
                <div>
                  <el-tooltip content="通过国际群组，限制使用区域" placement="top">
                      <i class="el-icon-question"></i>
                  </el-tooltip>
                  <span>使用区域</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="countryNames" align="center" width="180">
              <template #header>
                <div>
                  <el-tooltip content="可以使用的国家，超出区域，停机处理" placement="top">
                      <i class="el-icon-question"></i>
                  </el-tooltip>
                  <span>区域限制使用国家</span>
                </div>
              </template>
              <template #default="{row}">
                <div class="product-list" v-if="row.countryNames && row.countryNames.length > 0">
                  <div class="product-item" v-for="(item,index) in row.countryNames.slice(0, 1)" :key="index" :title="item">
                        <span>{{item}}</span>
                  </div>
                  <span class="el-dropdown-link" v-if="row.countryNames.length>1" @click="showMoreCountry(row)">
                    <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="currency" align="center" width="180">
              <template #header>
                <div>
                  <el-tooltip content="可以使用货币购买此套餐" placement="top">
                      <i class="el-icon-question"></i>
                  </el-tooltip>
                  <span>支持币种</span>
                </div>
              </template>
              <template #default="{ row }">
                <el-select
                  v-model="row.currency"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择货币代码"
                  style="width: 140px"
                  @change="handleCurrencyChange(row,internationalPrice)"
                >
                  <el-option
                    v-for="item in currencyList"
                    :key="item.id"
                    :label="item.name + '[' + item.currency + ']'"
                    :value="item.currency"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="exchangeRateCny" label="汇率（货币符号）" align="center" width="130">
              <template #default="{row}">
                {{row.exchangeRateCny || '无'}}（{{row.currencySymbol || '无'}}）
              </template>
            </el-table-column>
            <el-table-column prop="price" align="center" width="200">
              <template #header>
                <div>
                  <el-tooltip content="比例代理商H5展示价格" placement="top">
                      <i class="el-icon-question"></i>
                  </el-tooltip>
                  <span>售价</span>
                </div>
              </template>
              <template #default="{row}">
                <el-input style="width: 170px;"  v-model="row.price"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                  <template #append>{{row.currencySymbol}}</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template #default="{ row }">
                <template v-if="row.leaf" >
                  <i class="el-icon-remove-outline" @click="removeCurrencyRow('currencyTable',row)" style="font-size:25px;color: #ff4949"></i>
                </template>
                <template v-else>
                  <i class="el-icon-remove-outline" @click="removeParentCurrencyRow(row)" style="font-size:25px;color: #ff4949;margin-left:10px"></i>
                  <i class="el-icon-circle-plus-outline" @click="addCurrencyRow('currencyTable',row)" style="font-size:25px;color: #1890ff;margin-left:10px"></i>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <div class="dialog-footer" slot="footer">
				<el-button @click="handleSubmit" type="primary" plain>确认修改</el-button>
			</div>
    </el-dialog>
    <el-dialog title="新增使用区域" :visible.sync="nextOperatorOpen" width="1300px"  :modal-append-to-body="true" :close-on-click-modal="false" :destroy-on-close="true" @close="closeOperator">
      <el-form  :inline="true" label-width="68px">
        <div style="display: flex; justify-content: space-between; width: 100%;">
          <div style="flex: 1; text-align: left;">
            <el-form-item prop="countryName">
              <el-input v-model="keyword"  placeholder="区域名称" clearable style="width: 210px"/>
            </el-form-item>
          </div>
          <div style="flex: 1; text-align: left;">
            <el-form-item>
              <el-input v-model="basePrice" placeholder="人民币价格" style="width:130px"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
              </el-input>
              <el-button type="primary" size="mini" @click="handleUpdateBasePrice" style="margin-left: 10px">按汇率设置价格</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="dialog-operator">
        <el-table ref="treeTable" :data="countryGroupData" @selection-change="handleSelectionChange" :row-class-name="hideCheckbox" row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column type="selection" align="center" width="60px"></el-table-column>
          <el-table-column prop="name" label="限制区域" align="center" width="180"></el-table-column>
          <el-table-column prop="countryNames" label="国家" align="center" width="180">
            <template slot-scope="{row}">
              <div class="product-list" v-if="row.countryNames && row.countryNames.length > 0">
                <div class="product-item" v-for="(item,index) in row.countryNames.slice(0, 1)" :key="index" :title="item">
                      <span>{{item}}</span>
                </div>
                <span class="el-dropdown-link" v-if="row.countryNames.length>1" @click="showMoreCountry(row)">
                  <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="currency" label="货币代码" align="center" width="180">
            <template #default="{ row }">
              <el-select
                v-model="row.currency"
                filterable
                allow-create
                default-first-option
                placeholder="请选择货币代码"
                style="width: 140px"
                @change="handleCurrencyChange(row,basePrice)"
              >
                <el-option
                  v-for="item in currencyList"
                  :key="item.id"
                  :label="item.name + '[' + item.currency + ']'"
                  :value="item.currency"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="exchangeRateCny" label="汇率" align="center" width="100"></el-table-column>
          <el-table-column prop="currencySymbol" label="货币符号" align="center" width="120"></el-table-column>
          <el-table-column prop="price" align="center" min-width="200">
            <template #header>
              <div>
                <el-tooltip content="比例代理商H5展示价格" placement="top">
                    <i class="el-icon-question"></i>
                </el-tooltip>
                <span>支付售价</span>
              </div>
            </template>
            <template #default="{row}">
              <el-input style="width: 170px;"  v-model="row.price"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                <template #append>{{row.currencySymbol}}</template>
              </el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
			<div class="dialog-footer" slot="footer">
				<el-button @click="confirmCountry" type="primary" plain>确认添加</el-button>
			</div>
    </el-dialog>
    <!-- 展示更多国家列表 -->
    <el-dialog title="国家列表" :visible.sync="moreCountryOpen" width="600px" append-to-body :close-on-click-modal="false">
      <el-input placeholder="请输入内容" v-model="searchQuery" clearable style="width: 30%"></el-input>
       <div class="tag-container">
        <el-tag
          v-for="item in filteredTableData"
          :key="item"
          type="success"
          class="custom-tag"
        >
          {{ item }}
        </el-tag>
      </div>
    </el-dialog>
  </div>
</template>

<script>
function debounce(fn, delay = 300) {
  let timer = null;
  const debounced = function(...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
      timer = null;
    }, delay);
  };
  // 增加取消方法，避免内存泄漏
  debounced.cancel = () => {
    clearTimeout(timer);
    timer = null;
  };
  return debounced;
}
import { currencyList } from "@/api/config.js"
import { selectGroupChannel , updateUserInternationalProductPrice, getUserInternationalProduct } from "@/api/international.js";
export default {
  props: {
    // 代理商userId
    updateProduct: {
      type: Object
    },
  },

  data() {
    return {
      // 遮罩层
      visible: false,
      title:"国际套餐配置价格",
      //选中的套餐
      customProducts:[],
      propsParams:{
        countryPrices:[]
      },
      searchCountry:'',
      filteredCountryPrices: [],
      currencyList:[],
      nextOperatorOpen:false,
      operatorData:[],
      multipleSelectionCountry:[],
      moreCountryOpen:false,
      moreCountryData:[],
      searchQuery:'',
      countryGroupData:[],
      originalCountryGroupData:[],
      internationalPrice:'',
      basePrice:'',
      keyword:'',
      debouncedFilter: null // 防抖函数实例

    };
  },
  watch: {
    updateProduct(newVal, oldVal) {
      this.initData(newVal);
    },
    'propsParams.countryPrices': {
      handler(newVal) {
        this.filteredCountryPrices = newVal;
      },
      deep: true
    },
    keyword(newVal, oldVal) {
      this.debouncedFilter();
    }
  },
  computed: {
    filteredTableData() {
      return this.moreCountryData.filter(row => {
        return Object.values(row).some(value => {
          return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
        });
      });
    },
    
  },
  created(){
    this.getCurrencyList()
    this.debouncedFilter = debounce(() => {
      this.filteredCountryGroupData()
    }, 300).bind(this);
  },
  beforeDestroy() {
    if (this.debouncedFilter && this.debouncedFilter.cancel) {
      this.debouncedFilter.cancel();
    }
  },
  methods: {
    // 显示弹框
    show() {
      this.visible = true;
      this.searchCountry = ''
      this.internationalPrice = ''
    },
    //查找货币
    getCurrencyList(){
      currencyList().then(res=>{
        this.currencyList = res.data.data
      })
    },
    initData(params){
      getUserInternationalProduct(params).then(res=>{
        this.propsParams = res.data.data
        this.propsParams.userId = params.userId
        this.propsParams.productId = params.productId
        this.filteredCountryPrices = this.propsParams.countryPrices;
      })
    },
    searchCountryPrices() {
      if (!this.searchCountry) {
        this.filteredCountryPrices = this.propsParams.countryPrices;
        return;
      }
      const query = this.searchCountry.toLowerCase();
      this.filteredCountryPrices = this.propsParams.countryPrices.filter(item => {
        return Object.values(item).some(value => {
          if (typeof value === 'string') {
            return value.toLowerCase().includes(query);
          }
          return false;
        });
      });
    },
    transferProductType(status) {
      let obj = {
        1: "累计套餐",
        2: "月套餐",
        3: "加油包套餐",
        4: "停机保号套餐",
        5: "补卡套餐",
        6: "加速包套餐",
        7: "测试套餐",
        8: "赠送套餐",
        9: "发票套餐",
        10: "流量池加油包"
      };
      return obj[status];
    },
    deleteOperatorPrice(row){
      let services = this.propsParams.countryPrices;
      for (let i = services.length - 1; i >= 0; i--) {
        if(services[i].id === row.id){
          services.splice(i, 1);
        }
      }
    },
    handleSubmit(){
      updateUserInternationalProductPrice(this.propsParams).then(res=>{
        this.visible = false;
        //父组件传值
        this.$emit("ok");
      })
    },
    hideCheckbox({ row, rowIndex }) {
      // 根据条件决定是否隐藏复选框
      if (row.leaf) {
        return 'hide-checkbox';
      }
      return '';
    },
    addCurrencyRow(ref,row) {
      if (!row.children) {
        this.$set(row, 'children', []);
      }
      const newRow = {
        id: `${row.id}_${row.children.length + 1}`,
        parentId: row.id,
        name: '',
        englishName: '',
        currency: '',
        currencySymbol: '',
        price: '',
        leaf : true  //标记为叶子节点
      };
      // 将新行添加到当前行的 children 数组中
      row.children.push(newRow);
      this.$nextTick(() => {
        this.$refs[ref].toggleRowExpansion(row, true);
      });
    },
    handleCurrencyChange(row,price){
      const selectedCurrency = this.currencyList.find(
        item => item.currency === row.currency
      );
      if (selectedCurrency) {
        row.currencySymbol = selectedCurrency.currencySymbol;
        row.exchangeRateCny = selectedCurrency.exchangeRateCny
        const basePrice = Number(price);
        if (!isNaN(basePrice) && basePrice > 0) {
          const exchangeRate = Number(row.exchangeRateCny);
          if (!isNaN(exchangeRate) && exchangeRate > 0) {
            const calculatedPrice = (basePrice * exchangeRate).toFixed(2);
            this.$set(row, 'price', calculatedPrice);
          }
        }
      }
    },
    handleUpdateInternationalPrice(){
      let price = this.internationalPrice
      if (isNaN(price) || price <= 0) {
        this.$message.warning("请输入有效的人民币价格");
        return;
      }

      const updateItemPrice = (item) => {
        const exchangeRate = Number(item.exchangeRateCny);
        // 检查汇率是否有效，有效则更新价格
        if (!isNaN(exchangeRate) && exchangeRate > 0) {
          const calculatedPrice = (price * exchangeRate).toFixed(2);
          this.$set(item, 'price', calculatedPrice);
        }
        // 如果有子节点，递归处理子节点
        if (item.children && item.children.length > 0) {
          item.children.forEach(child => updateItemPrice(child));
        }
      };
      // 遍历顶层节点并递归处理
      this.propsParams.countryPrices.forEach(item => {
        updateItemPrice(item);
      });
    },
    handleUpdateBasePrice(){
      let price = this.basePrice
      if (isNaN(price) || price <= 0) {
        this.$message.warning("请输入有效的人民币价格");
        return;
      }
      const updateItemPrice = (item) => {
        const exchangeRate = Number(item.exchangeRateCny);
        // 检查汇率是否有效，有效则更新价格
        if (!isNaN(exchangeRate) && exchangeRate > 0) {
          const calculatedPrice = (price * exchangeRate).toFixed(2);
          this.$set(item, 'price', calculatedPrice);
        }
        // 如果有子节点，递归处理子节点
        if (item.children && item.children.length > 0) {
          item.children.forEach(child => updateItemPrice(child));
        }
      };
      // 遍历顶层节点并递归处理
      this.countryGroupData.forEach(item => {
        updateItemPrice(item);
      });
    },
    removeCurrencyRow(type,row) {
      let data = type == 'treeTable'? this.countryData : this.propsParams.countryPrices
      const parentRow = data.find(item => item.id === row.parentId);
      if(parentRow  && parentRow.children){
        const childIndex = parentRow.children.findIndex(child => child.id === row.id);
        if(childIndex !== -1){
          parentRow.children.splice(childIndex, 1);
        }
      }
    },
    removeParentCurrencyRow(row){
      let data =  this.propsParams.countryPrices
      const parentIndex = data.findIndex(item => item.id === row.id);
      if(parentIndex !== -1){
        data.splice(parentIndex, 1);
      }
    },
    showMoreCountry(item){
      this.moreCountryOpen = true
      this.moreCountryData = item.countryNames
    },
    //移除所有区域
    removeSelectProductCountry(){
      this.propsParams.countryPrices = []
    },
    handleSelectGroupsData(){
      this.nextOperatorOpen = true
      this.keyword = '';
      let channel = this.updateProduct.channel
      this.countryGroupData = []
      selectGroupChannel({channel}).then(res=>{
        let  countryData = res.data.data
        countryData.forEach(item=>{
          item.price = 0
        })
        this.originalCountryGroupData = countryData
        this.filteredCountryGroupData()
      })
    },
    filteredCountryGroupData() {
      // 保存当前选中的ID
      const selectedIds = this.multipleSelectionCountry.map(item => item.id);
      
      if (!this.keyword) {
        this.countryGroupData = this.originalCountryGroupData
      } else {
        const query = this.keyword.toLowerCase();
        this.countryGroupData = this.originalCountryGroupData.filter(item => {
          return item.name.toLowerCase().includes(query);
        });
      }
      
      // 在下一个DOM更新周期后恢复选中状态
      this.$nextTick(() => {
        if (this.$refs.treeTable) {
          // 先清空所有选中
          this.$refs.treeTable.clearSelection();
          // 重新选中之前选中的项
          this.countryGroupData.forEach(item => {
            if (selectedIds.includes(item.id)) {
              this.$refs.treeTable.toggleRowSelection(item, true);
            }
          });
        }
      });
    },
    // 监听选中变化，确保multipleSelectionCountry始终包含所有选中的项
    handleSelectionChange(select) {
      // 获取当前搜索结果中所有行的ID
      const currentPageIds = new Set(this.countryGroupData.map(item => item.id));
      
      // 保存所有已选中的ID
      const allSelectedIds = new Set(this.multipleSelectionCountry.map(item => item.id));
      
      // 获取当前页面选中的ID
      const currentPageSelectedIds = new Set(select.map(item => item.id));
      
      // 处理当前页面的选择状态
      currentPageIds.forEach(id => {
        if (currentPageSelectedIds.has(id)) {
          // 如果当前页面的行被选中，添加到所有选中ID中
          allSelectedIds.add(id);
        } else {
          // 如果当前页面的行被取消选中，从所有选中ID中移除
          allSelectedIds.delete(id);
        }
      });
      
      // 构建新的选中数组
      const allSelected = [];
      // 从原始数据中查找所有选中的项
      this.originalCountryGroupData.forEach(item => {
        if (allSelectedIds.has(item.id)) {
          allSelected.push(item);
        }
      });
      
      this.multipleSelectionCountry = allSelected;
    },
    resetGroup(){
      this.handleSelectGroupsData()
    },
    confirmCountry(){
      this.nextOperatorOpen = false
      let scs = this.propsParams.countryPrices.map(m=>m.id)
      let countries = this.multipleSelectionCountry.filter(item=>scs.indexOf(String(item.id)) === -1)
      this.propsParams.countryPrices.push(...countries)
    },
    closeOperator(){
      this.basePrice = ''
      this.multipleSelectionCountry = []
    }
    
  }
};
</script>
<style scoped lang="less">
::v-deep .update-international-product-dialog{
  .el-dialog__body{
    padding: 2px 20px;
  }
}
.dialog-footer {
  text-align: center;
  padding: 15px 0;
}
::v-deep .hide-checkbox .cell .el-checkbox__input {
  display: none !important;
}
.el-select {
  width: 350px;
  margin-left: 5px;
}
.el-input {
  width: 350px;
  margin-left: 5px;
}
.el-button {
  margin-left: 5px;
  border-radius: 3px;
  padding: 10px 20px;
}
.cell button {
  width: 50px;
  font-size: 12px;
  text-align: center;
  padding: 6px;
}
.el-message-box__btns .el-button--small {
  width: 75px;
}
.dialog-operator{
    overflow: auto;
    max-height: 434px;
    border-top: 1px solid #eff1f4;
    border-bottom: 1px solid #eff1f4;
    padding: 0px 10px 11px 27px;
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #8798AF;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
}
.form-item-wrapper {
  display: flex;
  justify-content: space-between;
  width: 20%;
  .inline-form-item {
    width: auto; 
    box-sizing: border-box;
    padding: 0 5px; 
  }
}

.form-item-operator{
  overflow: auto;
  max-height: 500px;
}

.product-list{
  display: flex; 
  flex-wrap: wrap;
  width: 600px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 60px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; 
    margin: 5px; 
    background: #ecf5ff; 
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
  .el-dropdown-link{
    cursor: pointer;
    color: #409EFF;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    margin: 5px;
    line-height: 30px;
    -ms-flex-line-pack: start;
    align-content: flex-start;

  }
}
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px; 
  padding-top: 10px; 
  .custom-tag {
    margin: 0; 
  }
}

</style>
